import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const MARCH_2025_CAMPAIGN_END_DATE = d(2025, 4, 30, 12, 0);
